import { Box, Icon, Text, dimensions } from '@factorialco/deprecated-design-system'
import { ActivityLogLog } from 'generated/resources/graphql'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import { EmptyState } from '../EmptyState'
import { Item } from '../Item'

interface Props {
  upgradeElement?: React.ReactNode
  logs: ActivityLogLog[]
}

type LogsByDay = {
  [key: string]: ActivityLogLog[]
}

export const Timeline = ({ logs, upgradeElement }: Props) => {
  const logsByDate = logs.reduce<LogsByDay>((acc, log) => {
    const date = new Date(log.logDate)
    const key = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

    if (!acc[key]) {
      acc[key] = []
    }

    acc[key]?.push(log)

    return acc
  }, {})

  if (!upgradeElement && Object.keys(logsByDate).length === 0) return <EmptyState />

  return (
    <Box flexDirection="row" width="full" paddingTop="s16">
      <Box
        background="grey300"
        style={{ width: '2px', marginLeft: dimensions.s24, marginTop: dimensions.s16 }}
      />
      {Object.keys(logsByDate).length > 0 && (
        <Box width="full">
          {Object.entries(logsByDate).map(([date, logValues]) => {
            const dateFormatted = moment(date).format('dddd, LL')

            const today = moment(date).isSame(moment(), 'day')

            return (
              <>
                <Box flexDirection="row" alignItems="center">
                  <Box
                    style={{ marginLeft: `calc(-${dimensions.s6} - ${dimensions.s1})` }}
                    paddingY="s12"
                  >
                    <Icon.Tiny icon="circle" color="grey800" />
                  </Box>
                  <Box paddingLeft="s16" data-testid="log-date">
                    <Text.Normal size="200" color="grey800" weight="medium">
                      {today ? i18n.t('common.today') : dateFormatted}
                    </Text.Normal>
                  </Box>
                </Box>
                <>
                  {(upgradeElement ? [logValues.at(0)] : logValues)?.map((log, index) => (
                    <> {log && <Item key={index} log={log} />} </>
                  ))}
                </>
              </>
            )
          })}
        </Box>
      )}
      {upgradeElement && upgradeElement}
    </Box>
  )
}
